import script from "./TrendingCoins.vue?vue&type=script&setup=true&lang=js"
export * from "./TrendingCoins.vue?vue&type=script&setup=true&lang=js"

import "./TrendingCoins.vue?vue&type=style&index=0&id=7f02e2b4&lang=scss"

const __exports__ = script;

export default __exports__